import Page from "components/Page"
import HomeHeroArtwork from "components/HomeHeroArtwork"

const AboutPage = () => {
  return (
    <Page>
      <div className="grid min-h-[calc(100vh-9rem)] grid-cols-1 xl:grid-cols-[minmax(0,1.18fr)_minmax(330px,0.82fr)] gap-10 xl:gap-20 items-start">
        <div className="order-1">
          <HomeHeroArtwork />
        </div>

        <div className="order-2 max-w-3xl xl:max-w-none">
          <h1 className="sr-only">r4v3n</h1>

          <figure className="mb-6 grid grid-cols-[6.5rem_1fr] items-end gap-4 sm:grid-cols-[7rem_1fr]">
            <img
              src="/media/r4v3n.jpg"
              alt="r4v3n"
              className="w-full bg-gallery-surface object-cover"
            />
            <figcaption className="gallery-label text-gallery-muted leading-relaxed sm:self-center">
              photo by Rainer Hosch
            </figcaption>
          </figure>

          <div className="space-y-4 text-sm leading-relaxed text-gallery-text">
            <p>
              r4v3n (pronounced &ldquo;raven,&rdquo; b. 1988, American). Artist. His practice &mdash;
              visible in the collections Moments, Pieces of Me, Color Streams, and Marfa: Middle of
              Somewhere &mdash; engages the lineage of abstract expressionism and color field painting
              through code, print, and photography.
            </p>
            <p>
              His work has been released through Art Blocks (Moments and Pieces of Me, both part of the
              AB500), SuperRare, Bright Moments (Color Streams), and Plottables (Shields). Alongside the
              practice, he hosts Studio Visit, a long-form conversation series with the artists,
              collectors, and builders shaping generative art, and Beyond the Blocks, a video series
              made with Art Blocks.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-3">
            <a href="/projects" className="gallery-btn-primary text-sm">
              View Work
            </a>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default AboutPage
